import { TimelineStep, StepBoundary } from '../types/timeline';

export const MINIMUM_STEP_LENGTH_FRAMES = 1;

export function clampFrame(frame: number, totalFrames: number): number {
  return Math.min(totalFrames, Math.max(0, Math.round(frame)));
}

export function sanitizeStep(
  step: TimelineStep,
  totalFrames: number,
  minimumStepLengthFrames: number = MINIMUM_STEP_LENGTH_FRAMES
): TimelineStep {
  let startFrame = clampFrame(step.startFrame, totalFrames);
  let endFrame = clampFrame(step.endFrame, totalFrames);

  if (endFrame - startFrame < minimumStepLengthFrames) {
    if (startFrame + minimumStepLengthFrames <= totalFrames) {
      endFrame = startFrame + minimumStepLengthFrames;
    } else {
      endFrame = totalFrames;
      startFrame = Math.max(0, endFrame - minimumStepLengthFrames);
    }
  }

  if (startFrame >= endFrame) {
    endFrame = Math.min(totalFrames, startFrame + minimumStepLengthFrames);
    startFrame = Math.max(0, Math.min(startFrame, endFrame - minimumStepLengthFrames));
  }

  return {
    ...step,
    startFrame,
    endFrame,
  };
}

export function updateStepBoundary(
  step: TimelineStep,
  boundary: StepBoundary,
  nextFrame: number,
  totalFrames: number,
  minimumStepLengthFrames: number = MINIMUM_STEP_LENGTH_FRAMES
): TimelineStep {
  const frame = clampFrame(nextFrame, totalFrames);

  if (boundary === 'start') {
    const maxStart = step.endFrame - minimumStepLengthFrames;
    return {
      ...step,
      startFrame: Math.max(0, Math.min(frame, maxStart)),
    };
  }

  const minEnd = step.startFrame + minimumStepLengthFrames;
  return {
    ...step,
    endFrame: Math.min(totalFrames, Math.max(frame, minEnd)),
  };
}
